import { extend } from 'flarum/extend';
import TextEditor from 'flarum/components/TextEditor';

export default function () {
  extend(TextEditor.prototype, 'toolbarItems', function(items) {
    const listOfToolbarItemsToRemove = [
      "fas fa-quote-left",
      "fas fa-code",
      "fas fa-link",
      "fas fa-image"
    ];

    if(items.has('markdown')) {
      const markdownToolbarItems = items.get('markdown').children;
      // We need to remove these in reverse order so indexes to be removed do not change.
      for (let i = markdownToolbarItems.length - 1; i >= 0; i--) {
        if (listOfToolbarItemsToRemove.includes(markdownToolbarItems[i].attrs.icon)) {
          markdownToolbarItems.splice(i, 1);
        }
      }
    }
  });
}
